export const getCompanyConfig = ({ Company: { config } }) => config;
